


































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import {IEditor, Editor,CustomDirectEditProvider} from '@/agiles/common/validator';

@Component
export default class ReceivePaymentView extends Vue {
  public items: Common.Payment[] = new Array(0);
  public params: Common.PaymentQuery = new Common.PaymentQuery(Common.PaymentFlags.Send);
  public importQuery = new Common.PaymentImportQuery('支払',true);
  public exportQuery = new Common.PaymentExportQuery('支払',this.params,true);
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'paymentNo', text: '支払番号' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'bookDate', text: '支払日' },
    { value: 'bankAccount', text: '支払口座' },
    { value: 'segment', text: '部門' },
    { value: 'paymentFlag', text: '支払区分' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];
  @Prop() public paymentNo:string;
  public Common = Common;

  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ  
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([], 0, 'grid');
  public taxTypes = Common.TaxTypes;
  public paymentStatus = Common.PaymentStatus;

  public created() {

    //'状態', '支払番号', '部門', '担当者', '仕入先', '取引通貨', '支払日', '支払口座', '口座支払額', '手数料額', '決済金額', '支払額合計', '摘要', '支払区分', 'ワークフロー', '初回保存日', '初回保存者', '最終更新日', '最終更新者'
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    //'状態', '入金番号','ワークフロー', '部門', '担当者', '得意先', '取引通貨', '入金日', '入金口座', '口座入金額',
    // '手数料額', '決済金額', '入金額合計',  '入金区分',  '初回保存日', '初回保存者', '最終更新日', '最終更新者'
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('支払番号', 120),      
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('仕入先', 150),
      new Common.GridItemConfiguration('支払日', 150),
      new Common.GridItemConfiguration('支払口座', 150),            
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('決済金額', 150),
      new Common.GridItemConfiguration('手数料額', 150),
      new Common.GridItemConfiguration('手数料税区分', 180),
      new Common.GridItemConfiguration('口座支払額', 150),
      new Common.GridItemConfiguration('支払レート', 150,this.hasLicenseCurrency),         
      new Common.GridItemConfiguration('支払区分', 150),
      new Common.GridItemConfiguration('振込データ連携区分', 120),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),            


    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.paymentNo) {
      this.params.paymentNo = this.paymentNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.Payment) {
    const workflows = this.$api.formatter.getOptions('workflow_sendPayment');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.paymentFlag = Common.PaymentFlags.SendPurchaseDelivery;
    obj.exchangeRate = 1;
    obj.currencyCode = this.$api.tenantSettings.currencyCode;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.items[index] =  (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    this.$set(this.items, index, obj);
  }

  // 一覧選択時に明細一覧タブを更新
  public onSelectedMain(index: number, selected: Common.Payment) {
    // 明細一覧タブを更新
    this.journals = new Array(0);
    this.suspenseJournals = new Array(0);    
    if(index >= 0) this.refreshChargeItemtList();
  }

  public isEditable(item: Common.Payment){
    //支払消込がないこと
    return item.state == Common.PaymentStatus.PaymentPostWaiting && (item.paymentBalance == null ||  item.paymentBalance.creditJournals.length == 0);
  }

  // 明細一覧タブ更新用プロパティ
  public isLoading: boolean = false;
  public journals: Common.TransferJournal[]= new Array(0);

  // 明細一覧タブを更新
  public refreshChargeItemtList(){
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    // クエリを設定する
    var query = new Common.TransferJournalQuery();
    query.payment = (this.$refs.mainList as Components.ListView).selected;

    // サーバーから明細を取得する
    this.isLoading = true;
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.suspenseJournals = (res.result as Array<Common.TransferJournal>).filter(obj =>obj.journalType == Common.TransferJournalTypes.AccountPayable_SuspenseWriteoff);
      this.journals = (res.result as Array<Common.TransferJournal>).filter(obj =>obj.journalType != Common.TransferJournalTypes.AccountPayable_SuspenseWriteoff);      
        
      // this.journals = res.result;
      // payment.transferJournals = res.result;
    }).finally(()=>{
      this.isLoading = false;
    });
  }

  public  onChangeAmountFC(){
    if((this.$refs.mainEditor as Components.Editor).isEdit == false) return;
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    payment.amountFC = payment.settlementAmountFC + payment.commissionAmountFC;    
    // payment.transferJournals = this.journals;
    // if(this.journals.length > 0){
    //   payment.settlementAmountFC = this.journals.map(obj => obj.amountFC).reduce((total, value) => total + value);
    // }
    // else{
    //   payment.settlementAmountFC = 0;
    // // }
    // payment.amountFC = payment.settlementAmountFC + payment.commissionAmountFC;
  }
  public onChangeBankAccount(){
    if((this.$refs.mainEditor as Components.Editor).isEdit == false) return;
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    if(payment.bankAccount != null) payment.commissionTaxCode = payment.bankAccount.taxSystemCurrencyFee;
  }
  // 伝票へ遷移する
  public onPaymentNoClick(paymentNo: string){
    var flag = ((this.$refs.mainList as Components.ListView).selected as Common.Payment).paymentFlag;
    if (flag == Common.PaymentFlags.SendPurchaseOrder)
      this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',paymentNo));
    else if (flag == Common.PaymentFlags.SendPurchaseDelivery)
      this.$router.push(String.format('/purchase/PurchaseInvoice?invoiceNo={0}',paymentNo));
    else if (flag == Common.PaymentFlags.SendPurchaseCharge)    
      this.$router.push(String.format('/purchase/PurchaseCharge?chargeNo={0}',paymentNo));    
    else if (flag == Common.PaymentFlags.SendSalesCharge)    
      this.$router.push(String.format('/sales/SalesCharge?chargeNo={0}',paymentNo));        
  }    

  public onFBFileExport(){

      //バリデーション
      var targetItems =  (this.$refs.mainList as Components.ListView).selectedItems as Common.Payment[];
    // ダイアログ表示前バリデーション
    if(targetItems.length == 0){
      this.$api.modal.show('', '支払対象の伝票を選択して下さい。', true, null);
      return;
    }
    
    var firstItem = targetItems[0];

    if(targetItems.filter(item => item.bankAccount.code != firstItem.bankAccount.code).length > 0){
      this.$api.modal.show('', '同一の支払口座の伝票を選択してください。', true, null);
      return;
    } else if (targetItems.filter(item => item.bookDate.getTime() != firstItem.bookDate.getTime()).length > 0) {
      this.$api.modal.show('', '同一の支払日の伝票を選択してください。', true, null);
      return;      
    } else if (targetItems.filter(item => item.firmBankingStatus != Common.FirmBankingFlags.Applicable).length > 0) {
      this.$api.modal.show('', '振込データ連携区分が「出力対象」の伝票を選択してください。', true, null);
      return;      
    } else if (targetItems.filter(item => item.state != Common.PaymentStatus.PaymentProcessWaiting).length > 0) {
      this.$api.modal.show('', '状態が「支払完了待ち」の伝票を選択してください。\r\n「支払確定」や「完了取消」を実施してください。', true, null);
      return;      
    } else if (firstItem.bankAccount.useFirmBanking == false) {
      this.$api.modal.show('', '支払口座の振込データ連携を「使用する」に変更して、必要な情報を設定してください。', true, null);
      return;      
    } else if (targetItems.filter(item => item.counterpart.useFirmBanking == false).length > 0) {
      var msg = '以下の支払先の振込データ連携を「使用する」に変更して、必要な情報を設定してください。';
      targetItems.filter(item => item.counterpart.useFirmBanking == false).forEach(obj => msg += '\r\n' + obj.counterpart.name);
      this.$api.modal.show('', msg, true, null);
      return;      
    } 

    this.$api.modal.show('確認','振込データ連携で全銀ファイルの出力を行うと、状態が「完了」になります。処理を開始しますか？',false,()=>{
          //①全銀ファイルを出力する
          var exportQuery = new Common.FBFileExportQuery("全銀ファイル", targetItems);
          this.$api.download(exportQuery).then(()=>{
            //②出力ステータスが変更されるので一覧をリロードする
            (this.$refs.mainList as Components.ListView).reload();
          });
    });
      
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.Payment){
    if (item.paymentFlag == Common.PaymentFlags.SendPurchaseOrder)
      this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseOrderPayment, sourceNo : item.paymentNo},this.$el);
    else
      this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchasePayment, sourceNo : item.paymentNo},this.$el);
  }   


  //消込明細のダイレクトエディットサポートをするためのエディタ
  public suspenseJournals: Common.TransferJournal[] = new Array(0);
  public originalJournals: Array<Common.TransferJournal> = null;
  public getJournalEditor(isSuspense:boolean){

    var getter: ()=>Array<Common.TransferJournal> = () =>isSuspense == false ? this.journals : this.suspenseJournals;
    var setter:(items:Array<Common.TransferJournal>) =>void = items => {
      if(isSuspense == false) this.journals = items; 
      else this.suspenseJournals = items;
      };

    var listView = this.$refs.mainList as Components.ListView;
    var editor = new Editor();
    editor.isEdit = false;
    editor.owner = new CustomDirectEditProvider();
    editor.owner.onDirectEdit = () => {      
      this.originalJournals = getter();
      setter(this.$api.createBinder('TransferJournal',true).loadInstance(this.originalJournals));
    };    
    editor.owner.onDirectCommit = () => {
        var items = getter().filter((obj,index) => obj.amountFC != this.originalJournals[index].amountFC);
        this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,isSuspense, false, items))
        .then(res =>{this.$set(this.items, listView.currentId, res);})
        .catch(res => {setter(this.originalJournals)});        //エラーが出た場合は元戻し
    };
    editor.owner.onDirectClose = () =>{
      //ロールバック
      setter(this.originalJournals);
    }; 
    editor.owner.hasDirectPerm = () => {
      var editable =  isSuspense ? listView.selected.state >= Common.PaymentStatus.PaymentCompleted:  listView.selected.state < Common.PaymentStatus.PaymentProcessWaiting
      return editable && this.$api.perms.hasWorkflowPermission(listView.selected.workflowHolder);
    };    

    return editor;
  }
  //支払処理
  public writeoffIsSuspense:boolean = false;
  public showWriteoffDialog(item: Common.Payment, isSuspense:boolean){

    this.writeoffIsSuspense = isSuspense;
    this.$api.execute(new Common.PaymentJournalTargetQuery(item,isSuspense)).then(res=>{
      var dialog = this.$refs.writeoffDialog as Components.ListDialog;
      dialog.items = res as Array<Common.TransferJournal>;
      dialog.showDialog();
    });
  }
  public async submitWriteoffDialog(list: Array<Common.TransferJournal>){
    // 実行前バリデーション
    var items = list.filter(obj =>obj.amountFC !=0);
    if(items.length ==0){
      this.$api.modal.show('', String.format('{0}を指定してください。',this.writeoffIsSuspense ? '前払金額':'支払額'), true, null);
      return;
    }    
    var listView = this.$refs.mainList as Components.ListView;
    this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,this.writeoffIsSuspense, false, items)).then(res =>{
      this.$set(this.items, listView.currentId, res);
    });
  }
  //支払削除
  public submitWriteoffDelete(isSuspense:boolean){
      var listView = this.$refs.mainList as Components.ListView;
      var items = isSuspense ? (this.$refs.suspenseJournalListBox as Components.Grid).selectedItems:(this.$refs.transferJournalListBox as Components.Grid).selectedItems;
      if (items.length == 0) {
        this.$api.modal.show('無効な操作','削除対象を選択してください。',true,null);
        return;
      }

      this.$api.modal.showDialog('確認メッセージ',String.format('{0}件の{1}を削除してよろしいですか？',items.length, isSuspense ? '前払金':'支払'),false).then(()=>{
        this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,isSuspense, true, items)).then(res =>{
          this.$set(this.items, listView.currentId, res);
        });        
      });
  }

}
